<template>
    <el-dialog :title="cloudEditMode === 'batch' ? '批量编辑云商品SKU' : '编辑云商品SKU'" :visible.sync="innerVisible"
        :close-on-click-modal="false" top="5vh" width="86%" :before-close="handleBeforeClose">
        <div class="cloud-edit-container">
            <div class="cloud-edit-left" v-loading="cloudListLoading">
                <div class="panel-header cloud-edit-filter" v-if="cloudEditMode === 'batch'">
                    <div>
                        <!-- <span style="padding-right: 15px;">筛选</span> -->
                        <el-select v-model="searchParams.product_Status" placeholder="检测状态" filterable size="mini"
                            style="width: 150px;" @change="handleCloudEditFilterChange">
                            <el-option v-for="item in Object.keys(productStatus)" :key="item"
                                :label="productStatus[item].label" :value="productStatus[item].value"></el-option>
                        </el-select>
                        <el-select v-model="searchParams.cloudEditSkuStatus"
                            :disabled="searchParams.product_Status != 1" placeholder="全部状态" filterable clearable
                            size="mini" style="width: 140px; margin-left: 3px;" @change="handleCloudEditFilterChange">
                            <el-option v-for="item in Object.keys(skuViolcationStatus)" :key="item"
                                :label="skuViolcationStatus[item].label"
                                :value="skuViolcationStatus[item].value"></el-option>
                        </el-select>
                    </div>
                    <div style="margin-top: 2px;">
                        <!-- <span style="padding-right: 45px;"></span> -->
                        <el-select v-model="searchParams.task_no" :disabled="searchParams.product_Status != 1"
                            placeholder="批次" filterable clearable size="mini" style="width: 150px;"
                            @change="handleCloudEditFilterChange">
                            <el-option v-for="item in detection_task_list" :key="item.task_no" :label="item.task_no"
                                :value="item.task_no"></el-option>
                        </el-select>
                        <el-select v-model="searchParams.status" :disabled="searchParams.product_Status != 1"
                            placeholder="处理状态" filterable clearable size="mini" style="width: 140px; margin-left: 3px"
                            @change="handleCloudEditFilterChange">
                            <el-option v-for="item in Object.keys(status_list)" :key="item"
                                :label="status_list[item].label" :value="status_list[item].value"></el-option>

                        </el-select>
                    </div>
                    <div style="margin-top: 2px;">
                        <!-- <span style="padding-right: 45px;"></span> -->
                        <el-select v-model="searchParams.group_ids" placeholder="分组" filterable clearable multiple
                            collapse-tags size="mini" @change="changeGroupIds" style="width: 150px;">
                            <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                                :value="group.id"></el-option>
                        </el-select>
                        <!-- <span style="padding-right: 45px;"></span> -->
                        <el-select v-model="searchParams.child_group_ids" placeholder="子分组" filterable clearable
                            multiple collapse-tags size="mini" @change="handleCloudEditFilterChange" style="width: 140px; margin-left: 3px">
                            <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                                :value="group.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="panel-header" style="display: flex; align-items: center; justify-content: space-between;"
                    v-if="cloudEditMode === 'batch'">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <el-checkbox v-model="isAllChecked" @change="handleCheckAllChange">全选</el-checkbox>
                        <!-- <span>编辑SKU-商品： {{ cloudEditList.length }}/{{ cloudEditSourceList.length }}</span> -->
                    </div>
                    <div style="display: flex; gap: 1px;">
                        <el-button size="mini" v-if="searchParams.product_Status == 1" type="success"
                            @click="batchStatus(2)">无需整改</el-button>
                        <el-button size="mini" v-if="searchParams.product_Status == 1" type="danger"
                            @click="batchDelete(2)">删除异常</el-button>
                        <el-button size="mini" v-if="searchParams.product_Status == 1" type="warning"
                            @click="batchoffline(2)">下架</el-button>
                    </div>
                </div>
                <div class="edit-product-list">
                    <div v-for="item in cloudEditProductList" :key="item.id" class="edit-product-item"
                        :class="{ active: cloudEditCurrent && cloudEditCurrent.id === item.id }"
                        @click="handleCloudEditSelect(item)">
                        <div class="edit-product-main">
                            <el-checkbox :value="checkedItems.includes(item.id)"
                                @change="(val) => handleCheckChange(val, item.id)"
                                v-if="cloudEditMode === 'batch'"></el-checkbox>
                            <div class="edit-product-top">
                                <el-image :src="item.import_product.main_image" class="edit-product-thumb"
                                    fit="cover"></el-image>
                                <div class="edit-product-info">
                                    <div class="edit-product-title" :title="item.import_product.title">{{
                                        item.import_product.title }}</div>
                                    <div class="edit-product-meta">¥{{ item.import_product.price }} <span
                                            v-if="!item.is_price_check"
                                            :class="item.status == 2 ? 'edit-product-status-final' : 'edit-product-status-process'">{{
                                                item.status == 2 ? '已整改' : '未整改' }}</span>
                                        <span v-if="item.is_price_check"
                                            :class="item.is_price_check == 2 ? 'edit-product-status-final' : 'edit-product-status-process'">{{
                                                item.is_price_check == 2 ? '已检测' : '未检测' }}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="edit-product-bottom">
                            <div style="color: #909399;">分组：{{ formatGroupName(item) }}</div>
                            <div style="color: rgb(255, 69, 0);">{{ getAbnormalSkuCount(item) }}</div>
                        </div>
                    </div>


                </div>
                <!-- <div class="edit-product-list">
                    <div v-for="item in cloudEditProductList" :key="item.id" class="edit-product-item"
                        :class="{ active: cloudEditCurrent && cloudEditCurrent.id === item.id }"
                        @click="handleCloudEditSelect(item)">
                        <el-image :src="item.import_product.main_image" class="edit-product-thumb"
                            fit="cover"></el-image>
                        <div class="edit-product-info">
                            <div class="edit-product-title" :title="item.import_product.title">{{
                                item.import_product.title }}</div>
                            <div class="edit-product-meta">¥{{ item.import_product.price }} <span
                                    :class="item.status == 2 ? 'edit-product-status-final' : 'edit-product-status-process'">{{
                                    item.status == 2?'已整改' : '未整改' }}</span></div>

                        </div>
                    </div>
                </div> -->
                <!-- <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" type="small"
                    @pagination="getDetectionDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total > 0" /> -->
                <div class="pagination-wrap">
                    <el-pagination v-if="page_data.total > 1" :current-page.sync="page_data.page"
                        :page-size.sync="page_data.limit" :pager-count="5" :total="page_data.total"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next" small
                        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>
            </div>
            <div class="cloud-edit-right" v-loading="cloudEditLoading">
                <el-form label-width="90px" size="small" v-if="cloudEditForm.id">
                    <el-form-item label="商品标题" required>
                        <el-input v-model="cloudEditForm.title" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="商品ID" required>
                        <div class="edit-image-actions">
                            <span>{{ cloudEditForm.product_id }}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品主图" required>
                        <div class="edit-image-actions"></div>
                        <div class="edit-image-list">
                            <div v-for="(url, index) in cloudEditForm.main_images" :key="url + index"
                                class="edit-image-item">
                                <el-image :src="url" fit="cover"
                                    :preview-src-list="cloudEditForm.main_images"></el-image>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="SKU" required>
                        <div class="sku-spec-editor readonly">
                            <div class="sku-spec-row" v-for="(spec, specIndex) in cloudEditForm.skuSpecs"
                                :key="specIndex">
                                <div class="sku-spec-name">{{ spec.name }}</div>
                                <div class="sku-spec-values">
                                    <el-tag v-for="(value, valueIndex) in spec.values" :key="valueIndex" closable
                                        size="small" @close="removeSkuSpecValue(specIndex, valueIndex)">
                                        {{ value }}
                                    </el-tag>
                                </div>
                            </div>
                        </div>
                        <div class="sku-action-bar">
                            <el-checkbox v-model="onlyShowColorViolation">只看异常SKU</el-checkbox>
                            <el-button size="mini" type="danger" @click="batchDeleteSkus(1)">批量删除选中SKU</el-button>
                        </div>
                        <div class="sku-value-image-editor"
                            v-if="cloudEditForm.skuSpecs.length && cloudEditForm.skuSpecs[0].name && cloudEditForm.skuSpecs[0].values.length">
                            <div class="sku-value-image-title">{{ cloudEditForm.skuSpecs[0].name }} 图片</div>
                            <div class="sku-value-image-list">
                                <div class="sku-value-image-item"
                                    v-for="(oldVal, idx) in cloudEditForm.skuSpecs[0].values"
                                    v-show="!onlyShowColorViolation || cloudEditForm.skuSpecs[0].isviolation[idx] == 1"
                                    :class="cloudEditForm.skuSpecs[0].isviolation[idx] == 1 ? 'violation-row' : ''"
                                    :key="idx">
                                    <el-checkbox :value="selectedColorSpecValues.includes(idx)"
                                        @change="(val) => toggleSpecValue(val, idx, 0)"></el-checkbox>
                                    <div class="sku-value-name">
                                        <el-input v-model="cloudEditForm.skuSpecs[0].values[idx]" size="mini"
                                            placeholder="规格值" @input="handleSpecValueChange(idx, oldVal, 0)"></el-input>
                                    </div>
                                    <el-image v-if="cloudEditForm.skuValueImages[cloudEditForm.skuSpecs[0].values[idx]]"
                                        :src="cloudEditForm.skuValueImages[cloudEditForm.skuSpecs[0].values[idx]]"
                                        :preview-src-list="[cloudEditForm.skuValueImages[cloudEditForm.skuSpecs[0].values[idx]]]"
                                        class="sku-value-thumb" fit="cover"></el-image>
                                    <el-button size="mini" icon="el-icon-delete" circle
                                        @click="removeSkuSpecValue(0, idx)"></el-button>
                                </div>
                            </div>
                        </div>
                        <div class="sku-action-bar"
                            v-if="cloudEditForm.skuSpecs.length && cloudEditForm.skuSpecs.length > 1 && cloudEditForm.skuSpecs[1].name && cloudEditForm.skuSpecs[1].values.length">
                            <el-checkbox v-model="onlyShowSizeViolation">只看异常SKU</el-checkbox>
                            <el-button size="mini" type="danger" @click="batchDeleteSkus(2)">批量删除选中SKU</el-button>
                        </div>
                        <div class="sku-value-image-editor"
                            v-if="cloudEditForm.skuSpecs.length && cloudEditForm.skuSpecs.length > 1 && cloudEditForm.skuSpecs[1].name && cloudEditForm.skuSpecs[1].values.length">
                            <div class="sku-value-image-title">{{ cloudEditForm.skuSpecs[1].name }} </div>
                            <div class="sku-value-image-list">
                                <div class="sku-value-image-item"
                                    v-for="(oldVal, idx) in cloudEditForm.skuSpecs[1].values" :key="idx"
                                    v-show="!onlyShowSizeViolation || cloudEditForm.skuSpecs[1].isviolation[idx] == 1"
                                    :class="cloudEditForm.skuSpecs[1].isviolation[idx] == 1 ? 'violation-row' : ''">
                                    <el-checkbox :value="selectedSizeSpecValues.includes(idx)"
                                        @change="(val) => toggleSpecValue(val, idx, 1)"></el-checkbox>
                                    <div class="sku-value-name">
                                        <el-input v-model="cloudEditForm.skuSpecs[1].values[idx]" size="mini"
                                            placeholder="规格值" @input="handleSpecValueChange(idx, oldVal, 1)"></el-input>
                                    </div>
                                    <el-button size="mini" icon="el-icon-delete" circle
                                        @click="removeSkuSpecValue(1, idx)"></el-button>
                                </div>
                            </div>
                        </div>
                        <div class="sku-value-image-editor">
                            <div class="sku-value-image-title">铺货策略价格公式</div>
                            <div class="sku-value-image-list">
                                <div>
                                    <span class="span_spacing">原价格 x</span>
                                    <el-input-number v-model.number="detection_info.coefficient" :precision="2" :min="1"
                                        :step="0.1" placeholder="倍数" size="small" @change="setDirty" />
                                    <span class="span_spacing">倍 + 加价</span>
                                    <el-input-number v-model.number="detection_info.coefficient_money" :precision="2"
                                        :min="1" :step="0.1" placeholder="金额" size="small" @change="setDirty" />
                                    <span class="span_spacing">元 x 折扣</span>
                                    <el-input-number v-model.number="detection_info.amount_discount" :precision="2"
                                        :step="1" :min="1" :max="10" placeholder="折扣" size="small" @change="setDirty" />
                                    <span class="span_spacing">折（{{ (parseFloat(detection_info.amount_discount) *
                                        0.1).toFixed(2) }}）</span>
                                </div>
                            </div>
                        </div>
                        <div class="sku-action-bar">
                            <el-checkbox v-model="onlyShowAllViolation">只看异常SKU</el-checkbox>
                            <el-button size="mini" type="danger" @click="batchDeleteSkus(3)">批量删除选中SKU</el-button>
                        </div>
                        <el-table :data="filteredSkus" border size="mini" class="edit-sku-table"
                            @selection-change="handleSelectionChange"
                            :row-class-name="({ row }) => (row.violationInfo && row.violationInfo.length && row.violationInfo[0] && row.violationInfo[0].length > 0) ? 'violation-row' : ''">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column label="状态" width="90" align="center">
                                <template slot-scope="{ row }">
                                    <el-tag :type="row.enabled ? 'success' : 'info'" size="mini">
                                        {{ row.enabled ? '保留' : '已移除' }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="规格" min-width="220" align="center">
                                <template slot-scope="{ row }">
                                    <span :class="{ 'sku-disabled-text': !row.enabled }">{{
                                        formatSkuAttributes(row.attributes) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="异常项" min-width="220" align="center">
                                <template slot-scope="{ row }">
                                    <template v-if="row.violationInfo && row.violationInfo.length">
                                        <el-tooltip v-for="key in row.violationInfo[0]" :key="key"
                                            v-if="row.violationInfo.length > 1" placement="top"
                                            :content="row.violationInfo[1] || getViolationLabel(key)">
                                            <el-tag size="mini" v-if="getViolationLabel(key)"
                                                :type="getViolationTagType(key)" style="margin: 2px;">
                                                {{ getViolationLabel(key) }}
                                            </el-tag>
                                        </el-tooltip>
                                    </template>
                                    <!-- <span v-else>无</span> -->
                                </template>
                            </el-table-column>

                            <el-table-column label="库存" width="100">
                                <template slot-scope="{ row }">
                                    <el-input-number v-model="row.stock" :disabled="!row.enabled" :min="0"
                                        :precision="0" :controls="false" @change="setDirty"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="价格" width="110" align="center">
                                <template slot-scope="{ row }">
                                    <el-input-number v-model="row.price" :disabled="!row.enabled" :min="0"
                                        :precision="2" :controls="false" @change="setDirty"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="铺货价格" width="100" align="center">
                                <template slot-scope="{ row }">
                                    <el-input-number :value="calcDistributePrice(row, 10)" disabled :min="0"
                                        :precision="2" :controls="false" />
                                </template>
                            </el-table-column>
                            <el-table-column label="折扣后价格" width="100" align="center">
                                <template slot-scope="{ row }">
                                    <el-input-number :value="calcDistributePrice(row, detection_info.amount_discount)"
                                        disabled :min="0" :precision="2" :controls="false" />
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="{ row }">
                                    <el-button v-if="row.enabled" type="danger" size="mini" icon="el-icon-delete" circle
                                        @click="batchDeleteSkus(3, row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-form>
                <el-empty v-else description="请选择左侧商品" :image-size="100"></el-empty>
            </div>
        </div>
        <template slot="footer">
            <span class="selected-info" v-if="cloudEditDirty">有未保存修改</span>
            <el-button @click="batchStatus(1)" v-if="searchParams.product_Status == 1" size="mini"
                type="success">无需整改</el-button>
            <el-button v-if="cloudEditCurrent && cloudEditCurrent.status == 1 && searchParams.product_Status == 1"
                @click="batchDelete(1)" size="mini" type="danger">删除异常</el-button>
            <el-button @click="batchoffline(1)" v-if="searchParams.product_Status == 1" size="mini"
                type="warning">下架</el-button>
            <el-tooltip content="保存后该商品状态恢复正常状态" placement="top">
                <el-button type="primary" :disabled="!cloudEditDirty" :loading="cloudEditSaving"
                    @click="submitCloudEdit" size="mini">保存</el-button>
            </el-tooltip>
            <el-button @click="handleBeforeClose" size="mini">关闭</el-button>
        </template>
    </el-dialog>
</template>

<script>
import Pagination from "@/components/pagination/pagination.vue";
import { mapActions } from "vuex";
export default {
    name: "CloudProductEditDialog",
    components: {
        Pagination,
    },
    props: {
        // 弹窗显示隐藏
        visible: {
            type: Boolean,
            default: false
        },
        // 编辑模式 single/batch
        cloudEditMode: {
            type: String,
            default: "single"
        },
        // 待编辑商品列表
        cloudEditList: {
            type: Array,
            default: () => []
        },

    },
    watch: {
        // 深度监听数组，数组赋值、push/splice 都会触发
        visible: {
            handler(newVal, oldVal) {
                this.searchParams = {
                    cloudEditSkuStatus: '',
                    task_no: '',
                    product_Status: 1,
                    status: '',
                    group_ids: [],
                    child_group_ids: [],
                },
                this.page_data = {
                    limit: 10,
                    page: 1,
                    total: 0,
                }
                if (this.cloudEditMode != 'single') {
                    this.getBatchLists()
                }
                if (this.visible) {
                    if (this.cloudEditList.length > 0) {
                        this.cloudEditProductList = this.cloudEditList
                        this.cloudEditCurrent = this.cloudEditProductList[0]
                        this.cloudEditSourceList = this.cloudEditProductList
                        if (this.detection_info?.task_no !== this.cloudEditCurrent.task_no) {
                            this.getDetectionInfo(this.cloudEditCurrent.task_no);
                        }
                        this.loadCloudEditDetail()
                    } else {
                        this.getDetectionDataList()
                    }

                }
            },
            immediate: true
        },
        cloudEditMode: {
            handler(newVal, oldVal) {
                if (newVal != 'single') {
                }
            },
            deep: true
        }
    },
    computed: {
        innerVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit("update:visible", val);
            }
        },
        filteredSkus() {
            if (!this.onlyShowAllViolation) {
                return this.cloudEditForm.skus;
            }
            return this.cloudEditForm.skus.filter(row =>
                row.violationInfo && row.violationInfo.length && row.violationInfo[0] && row.violationInfo[0].length > 0
            );
        },
    },
    created() {
        this.loadGroupList()
    },
    data() {
        return {
            cloudEditSaving: false,
            cloudEditDirty: false,
            cloudEditCurrent: null,
            cloudEditShow: false,
            cloudEditLoading: false,
            cloudListLoading: false,
            cloudEditProductList: [],
            cloudEditSourceList: [],
            cloudEditForm: {
                id: '',
                product_id: '',
                title: '',
                price: '',
                main_images: [],
                detail_images: [],
                skuSpecs: [],
                skus: [],
                skuValueImages: {},
            },
            detection_task_list: [],
            detection_info: {},
            skuViolcationStatus: {
                1: { label: '关键词违规', value: 1, type: 'selected-tag' },
                2: { label: '尺码违规', value: 2, type: 'replaced-tag' },
                3: { label: '高价限制', value: 3, type: 'notFond-tag' },
                4: { label: '低价限制', value: 4, type: 'notFond-tag' },
                5: { label: '价格倍数差', value: 5, type: 'notFond-tag' },
                6: { label: '价格差', value: 6, type: 'notFond-tag' },
                // 7: { label: '配件/耗材混卖', value: 7, type: 'notFond-tag' },
                // 8: { label: '非商品SKU', value: 8, type: 'notFond-tag' },
                // 9: { label: '异常拆分规格', value: 9, type: 'notFond-tag' },
                10: { label: '套装和单件混卖', value: 10, type: 'notFond-tag' },
                // 11: { label: '孤立低价SKU', value: 11, type: 'notFond-tag' },
                12: { label: '低价SKU引流', value: 12, type: 'notFond-tag' },
                // 13: { label: '铺货价与最低铺货价不一致。', value: 13, type: 'notFond-tag' },
                // 19: { label: '完成整改', value: 19, type: 'notFond-tag' },
            },
            productStatus: {
                1: { label: '已检测有异常', value: 1, type: 'selected-tag' },
                2: { label: '已检测无异常', value: 2, type: 'replaced-tag' },
                3: { label: '未检测', value: 3, type: 'notFond-tag' },
            },
            status_list: {
                1: { label: '待整改', value: 1, type: 'selected-tag' },
                2: { label: '已整改', value: 2, type: 'replaced-tag' },
            },
            page_data: {
                limit: 10,
                page: 1,
                total: 0,
            },
            checkedItems: [],
            onlyShowColorViolation: false,
            onlyShowSizeViolation: false,
            onlyShowAllViolation: false,
            selectedSkus: [],
            selectedColorSpecValues: [],
            selectedSizeSpecValues: [],
            selectedAllSpecValues: [],
            groupList: [],
            child_groupList: [],
            keyNameMap: {
                keyword: '关键词异常',
                size: '尺码异常',
                max_price: '高价限制',
                min_price: '低价限制',
                price_gap: '价格差',
                // price_gap: '价格倍数差',
                // price_abnormal: '综合价格异常',
                // 后续新增直接写这里
                // accessory: '配件耗材混卖',
                // sku_non_product: '非商品SKU',
                // spec_split: '异常拆分规格',
                set_single: '套装和单件混卖',
                // isolated_low_price: '孤立低价SKU',
                low_price_drain: '低价SKU引流',
                // supply_price: '铺货价不一致',
            },
            multipleSelection: [],
            searchParams: {
                cloudEditSkuStatus: '',
                task_no: '',
                product_Status: 1,
                status: '',
                group_ids: [],
                child_group_ids: [],
            },
            skuStatus: {
                1: { label: '已检测有异常', value: 1, type: 'selected-tag' },
                2: { label: '已检测无异常', value: 2, type: 'replaced-tag' },
            },

        }
    },
    methods: {
        ...mapActions({
            getCloudProductEditDetail: 'ucenter/getCloudProductEditDetail',
            opGetSkudetectionPage: 'ucenter/opGetSkudetectionPage',
            opOfflineSkudetection: 'ucenter/opOfflineSkudetection',
            opGetSkudetectionDetailPage: 'ucenter/opGetSkudetectionDetailPage',
            opPutEditsku: 'ucenter/opPutEditsku',
            opDelSkudetectionDetail: 'ucenter/opDelSkudetectionDetail',
            opPutSkudetectionDetail: 'ucenter/opPutSkudetectionDetail',
            getCloudProductGroups: 'ucenter/getCloudProductGroups',
        }),
        // 标记已修改
        setDirty() {
            this.cloudEditDirty = true
        },
        handleBeforeClose(done) {
            if (this.cloudEditDirty) {
                this.$confirm('当前商品有未保存修改，确认关闭商品吗？', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleClose();
                    if (typeof done === 'function') done();
                }).catch(() => { });
            } else {
                this.handleClose();
                if (typeof done === 'function') done();
            }
        },
        handleClose() {
            this.$emit("update:visible", false);
        },

        // 筛选切换
        handleCloudEditFilterChange() {
            this.getDetectionDataList()
        },
        // 删除规格值
        removeSkuSpecValue(specIndex, valueIndex) {
            let spec = this.cloudEditForm.skuSpecs[specIndex]
            if (!spec) return

            //设置sku状态 移除状态
            this.cloudEditForm.skus.forEach(item => {
                item.attributes.forEach(attribute => {
                    if (attribute.includes(spec.values[valueIndex])) {
                        item.enabled = false
                    }
                }
                )
            })
            this.cloudEditForm.skuSpecs = this.buildSkuSpecsFromSkus(this.cloudEditForm.skus)
            // spec = this.cloudEditForm.skuSpecs[specIndex]
            // spec.values.splice(valueIndex, 1)
            // spec.isviolation.splice(valueIndex, 1)
            this.setDirty()
        },
        // 格式化SKU原始属性
        normalizeSkuAttributes(attributes) {
            if (typeof attributes === "string") {
                try {
                    attributes = JSON.parse(attributes);
                } catch (e) {
                    attributes = [];
                }
            }
            if (attributes && typeof attributes === "object" && !Array.isArray(attributes)) {
                attributes = Array.isArray(attributes.specs) ? attributes.specs : [];
            }
            if (!Array.isArray(attributes)) return [];
            const specs = attributes.specs && Array.isArray(attributes.specs) ? attributes.specs : attributes;
            return specs
                .map((item) => {
                    if (Array.isArray(item)) {
                        return [String(item[0] || "").trim(), String(item[1] || "").trim()];
                    }
                    return [
                        String(item.name || item.attributeName || "").trim(),
                        String(item.value || item.attributeValue || "").trim()
                    ];
                })
                .filter((item) => item[0] && item[1]);
        },
        // 展示规格文本
        formatSkuAttributes(attributes) {
            const specs = this.normalizeSkuAttributes(attributes);
            return specs.length ? specs.map((item) => `${item[0]}:${item[1]}`).join(", ") : "默认规格";
        },
        // 计算铺货价格
        calcDistributePrice(row, amount_discount) {
            const price = Number(row.price || 0);
            const coeff = Number(this.detection_info.coefficient || 1);
            const addMoney = Number(this.detection_info.coefficient_money || 0);
            const result = (price * coeff + addMoney) * (parseFloat(amount_discount) * 0.1);
            const final = parseFloat(result.toFixed(2));
            return Math.max(final, 0);
        },
        // 切换左侧商品
        handleCloudEditSelect(item) {
            if (this.cloudEditCurrent && this.cloudEditCurrent.id === item.id) return
            const switchProduct = () => {
                if (this.detection_info?.task_no !== item.task_no) {
                    this.getDetectionInfo(item.task_no);
                }
                this.cloudEditCurrent = item
                this.loadCloudEditDetail()
            }
            if (this.cloudEditDirty) {
                this.$confirm('当前商品有未保存修改，确认切换商品吗？', '提示', {
                    confirmButtonText: '确认切换',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(switchProduct).catch(() => { })
            } else {
                switchProduct()
            }
        },
        // 获取检测配置信息（系数/加价/折扣）
        //获取检测列表
        getDetectionInfo(task_no) {
            this.detection_info = {}
            this.loading = true
            let param = { page_size: 1, page: 1, task_no: task_no }
            this.opGetSkudetectionPage({
                data: param,
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        const tableData = res.data.list
                        if (tableData && tableData.length > 0) {
                            this.detection_info = tableData[0]
                        }
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        // 加载商品编辑详情
        loadCloudEditDetail() {
            // 添加防抖，避免频繁调用
            if (this.cloudEditLoading) return;
            this.cloudEditLoading = true;
            this.cloudEditForm = {
                id: '',
                product_id: '',
                title: '',
                price: '',
                main_images: [],
                // detail_images: Array.isArray(data.detail_images) ? data.detail_images : [],
                skuSpecs: '',
                skus: [],
                skuValueImages: '',
            }
            this.selectedSkus = []
            this.selectedColorSpecValues = []
            this.selectedSizeSpecValues = []
            this.selectedAllSpecValues = []
            const id = this.cloudEditCurrent.import_product?.id || ''
            if (!id) {
                this.$message.error('选择商品不存在')
                return
            }

            this.getCloudProductEditDetail({
                id: id,
                success: (res) => {
                    this.cloudEditLoading = false
                    if (res.code === 200) {
                        this.cloudEditShow = true
                        this.cloudEditDirty = false
                        const data = res.data || {}
                        const skus = Array.isArray(data.skus) ? data.skus.map(item => ({
                            id: item.id,
                            attributes: this.normalizeSkuAttributes(item.attributes),
                            price: Number(item.price || 0),
                            stock: Number(item.stock || 0),
                            image_url: item.image_url || '',
                            enabled: item.enabled !== false && Number(item.status || 1) === 1,
                            violationInfo: this.handleViolationInfo(item.id)
                        })) : []
                        this.cloudEditForm = {
                            id: data.id,
                            product_id: data.product_id,
                            title: data.title || '',
                            price: data.price || '',
                            main_images: Array.isArray(data.main_images) ? data.main_images : [],
                            // detail_images: Array.isArray(data.detail_images) ? data.detail_images : [],
                            skuSpecs: this.buildSkuSpecsFromSkus(skus),
                            skus,
                            skuValueImages: this.buildSkuValueImagesFromSkus(skus),
                        }
                        this.cloudEditDirty = false
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        handleViolationInfo(skuid) {
            let abnormal_sku_ids = this.cloudEditCurrent.abnormal_sku_ids
            let remark = this.cloudEditCurrent.remark
            let sku_amount_abnormal_remark = this.cloudEditCurrent.sku_amount_abnormal_remark


            if (!abnormal_sku_ids) {
                return [];
            }
            const matchedKeys = [];
            try {
                const parsedIds = typeof abnormal_sku_ids === 'string' ? JSON.parse(abnormal_sku_ids) : abnormal_sku_ids;
                for (const key in parsedIds) {
                    if (Array.isArray(parsedIds[key]) && parsedIds[key].includes(skuid)) {
                        matchedKeys.push(key);
                    }
                }
            } catch (e) {
                console.error('Failed to parse abnormal_sku_ids', e);
                return [];
            }
            let resultStr = '';
            if (remark && typeof remark === 'string') {
                const remarkArr = remark.split('|');
                remarkArr.forEach(r => {
                    const trimmedR = r.trim();
                    if (trimmedR) {
                        try {
                            const parsedIds = typeof abnormal_sku_ids === 'string' ? JSON.parse(abnormal_sku_ids) : abnormal_sku_ids;
                            for (const key in parsedIds) {
                                if (Array.isArray(parsedIds[key]) && parsedIds[key].includes(trimmedR)) {
                                    resultStr += key + '、';
                                }
                            }
                        } catch (e) {
                            console.error('Failed to parse abnormal_sku_ids', e);
                        }
                    }
                });
            }

            if (sku_amount_abnormal_remark) {
                try {
                    const amountRemarkObj = typeof sku_amount_abnormal_remark === 'string' ? JSON.parse(sku_amount_abnormal_remark) : sku_amount_abnormal_remark;
                    if (amountRemarkObj && typeof amountRemarkObj === 'object') {
                        for (const key in amountRemarkObj) {
                            const item = amountRemarkObj[key];
                            if (item && String(item.SKU_ID) === String(skuid) && item['违规原因']) {
                                resultStr += item['违规原因'] + '\n';
                            }
                        }
                    }
                } catch (e) {
                    console.error('Failed to parse sku_amount_abnormal_remark', e);
                }
            }
            resultStr = resultStr ? resultStr.replace(/[、\n]+$/, '') : '';
            return [matchedKeys, resultStr];
        },
        // 根据sku生成规格列表
        buildSkuSpecsFromSkus(skus) {
            const specMap = []
            skus.forEach(sku => {
                this.normalizeSkuAttributes(sku.attributes).forEach(attr => {
                    if (sku.enabled) {
                        // console.log(sku);
                        let spec = specMap.find(item => item.name === attr[0])
                        if (!spec) {
                            spec = { name: attr[0], values: [], isviolation: [], inputVisible: false, inputValue: '' }
                            specMap.push(spec)
                        }
                        let isvio = 0;// 不违规
                        if (sku.violationInfo && sku.violationInfo[0] && sku.violationInfo[0].length > 0) {
                            isvio = 1;// 违规
                        }
                        if (!spec.values.includes(attr[1])) {
                            spec.values.push(attr[1])
                            spec.isviolation.push(isvio)
                        } else if (isvio == 1) {
                            let index = spec.values.indexOf(attr[1])
                            spec.isviolation[index] = isvio
                        }
                    }
                })
            })
            if (specMap.length === 0) {
                return [{ name: '默认规格', values: ['标准'], inputVisible: false, inputValue: '' }]
            }
            return specMap
        },
        // 生成规格对应图片映射
        buildSkuValueImagesFromSkus(skus) {
            const valueImages = {}
            skus.forEach(sku => {
                const attrs = this.normalizeSkuAttributes(sku.attributes)
                const firstValue = attrs[0] && attrs[0][1]
                if (firstValue && sku.image_url && !valueImages[firstValue]) {
                    valueImages[firstValue] = sku.image_url
                }
            })
            return valueImages
        },
        // 保存弹窗
        submitCloudEdit() {
            this.opPutEditsku({
                data: { id: this.cloudEditCurrent.id, product_id: this.cloudEditForm.product_id, skus: this.cloudEditForm.skus },
                success: (res) => {
                    if (res.code == 200) {
                        this.cloudEditDirty = false
                        const currentIndex = this.cloudEditProductList.findIndex(item => item.id === this.cloudEditCurrent.id);
                        this.cloudEditProductList[currentIndex].status = 2
                        if (currentIndex < this.cloudEditProductList.length - 1) {
                            this.cloudEditCurrent = this.cloudEditProductList[currentIndex + 1];
                            this.loadCloudEditDetail();
                        } else {
                            this.$message.success('保存成功，请翻页修改下一个商品');
                            return
                        }
                        this.$message.success('保存成功，进行一个商品整改。')
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        handleSpecValueChange(index, oldName, type) {
            this.cloudEditDirty = true
            let newName = this.cloudEditForm.skuSpecs[0].values[index]
            if (type == 0) {
                // 如果旧key存在图片，把图片数据迁移到新key
                if (this.cloudEditForm.skuValueImages[oldName]) {
                    this.cloudEditForm.skuValueImages[newName] = this.cloudEditForm.skuValueImages[oldName]
                    delete this.cloudEditForm.skuValueImages[oldName]
                }
            }
            if (type == 1) {
                newName = this.cloudEditForm.skuSpecs[1].values[index]
            }
            this.cloudEditForm.skus.forEach(item => {
                item.attributes.forEach((attribute, attrIdx) => {
                    if (attribute.includes(oldName)) {
                        const idx = attribute.indexOf(oldName);
                        if (idx !== -1) {
                            this.$set(item.attributes[attrIdx], idx, newName);
                        }
                    }
                }
                )
            })

            // 标记表单已修改
            this.setDirty()
        },
        getViolationLabel(key) {
            // const map = {
            //     keyword: '关键词异常',
            //     size: '尺码异常',
            //     min_price: '最低价异常',
            //     max_price: '最高价异常',
            //     price_gap: '价格差异常',
            //     price_abnormal: 'SKU价格等综合异常'
            // };
            return this.keyNameMap[key] || '';
        },
        getViolationTagType(key) {
            return 'danger'
            // const map = {
            //     keyword: 'danger',
            //     size: 'danger',
            //     min_price: 'danger',
            //     max_price: 'danger',
            //     price_gap: 'danger',
            //     price_abnormal: 'danger'
            // };
            // return map[key] || 'danger';
        },
        //批量下架
        batchoffline(type) {
            if (type == 1 && !this.cloudEditCurrent.id) {
                this.$message.error('请选择下架商品');
                return
            }
            if (type == 2 && this.checkedItems.length === 0) {
                this.$message.warning('请至少选择一个商品');
                return;
            }
            let messagetitle = `是否确定下架云商品?`
            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ids = '001'
                if (type == 1 && !this.cloudEditCurrent.id) {
                    ids = this.cloudEditCurrent.id
                }
                if (type == 2) {
                    ids = this.checkedItems.join(',')
                }
                this.opOfflineSkudetection({
                    data: { ids: ids },
                    success: (res) => {
                        if (res.code == 200) {
                            this.$message.success('下架成功，' + res.data + '个商品')
                            // this.getDataList()
                            this.getDetectionDataList();
                            this.checkedItems = [];
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        //读取批次号
        getBatchLists() {
            let param = { page_size: 20, page: 1 }
            this.opGetSkudetectionPage({
                data: param,
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.detection_task_list = res.data.list
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        handleSizeChange(val) {
            this.page_data.limit = val
            this.page_data.page = 1
            this.getDetectionDataList()
        },
        handleCurrentChange(val) {
            this.page_data.page = val
            this.getDetectionDataList()
        },
        //获取检测列表
        getDetectionDataList() {
            if (this.cloudListLoading) return;
            if (this.searchParams.product_Status !== 1) {
                this.searchParams.cloudEditSkuStatus = ''
                this.searchParams.status = ''
                this.searchParams.task_no = ''
            }
            // if (this.searchParams.product_Status == 3) {
            //     this.searchParams.cloudEditSkuStatus = ''

            // }
            this.cloudListLoading = true
            let param = {
                page_size: this.page_data.limit, page: this.page_data.page,
                task_no: this.searchParams.task_no, cloudEditSkuStatus: this.searchParams.cloudEditSkuStatus,
                product_Status: this.searchParams.product_Status,
                status: this.searchParams.status,
                group_ids: this.searchParams.group_ids,
                child_group_ids: this.searchParams.child_group_ids,
            }
            this.opGetSkudetectionDetailPage({
                data: param,
                success: (res) => {
                    this.cloudListLoading = false
                    // console.log(res)
                    if (res.code == 200) {
                        // this.tableData = res.data.list
                        if (res.data.list.length > 0) {
                            this.cloudEditProductList = res.data.list
                            this.cloudEditCurrent = this.cloudEditProductList[0]
                            this.cloudEditSourceList = this.cloudEditProductList
                            if (this.detection_info?.task_no !== this.cloudEditCurrent.task_no) {
                                this.getDetectionInfo(this.cloudEditCurrent.task_no);
                            }
                            this.loadCloudEditDetail()
                        } else {
                            this.cloudEditProductList = []
                            this.cloudEditCurrent = {}
                            this.cloudEditSourceList = []

                        }
                        this.page_data.total = res.data.total
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        //批量删除
        batchDelete(type) {
            if (type == 1 && !this.cloudEditCurrent.id) {
                this.$message.error('请选择下架商品');
                return
            } else if (type == 2) {
                if (this.checkedItems.length == 0 && this.task_no == '') {
                    this.$message.error('请选择异常sku信息，或着选择检测编号');
                    return
                }
            }
            let messagetitle = `是否确定删除选中的商品异常sku?`
            if (type == 2 && this.checkedItems.length == 0 && this.task_no != '') {
                messagetitle = `是否确定删除检测编号：${this.task_no}，所有异常sku？`;
            }

            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ids = '001'
                if (type == 1) {
                    ids = this.cloudEditCurrent.id
                } else if (type == 2) {
                    if (this.checkedItems.length > 0) {
                        ids = this.checkedItems.join(',')
                    } else {
                        ids = ''
                    }
                }
                this.opDelSkudetectionDetail({
                    data: { ids: ids, task_no: this.task_no },
                    success: (res) => {
                        if (res.code == 200) {
                            if (res.data > 0) {
                                this.$message.success('删除成功，' + res.data + 'sku')
                                if (type == 1) {
                                    this.cloudEditCurrent.status = 2
                                    this.loadCloudEditDetail()
                                } else {
                                    this.getDetectionDataList()
                                }
                                this.checkedItems = [];
                            } else {
                                this.$message.error('删除失败，未找到异常sku')
                            }
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        //批量修改状态
        batchStatus(type) {
            if (type == 1 && !this.cloudEditCurrent.id) {
                this.$message.error('请选择无异常商品');
                return
            } else if (type == 2) {
                if (this.checkedItems.length == 0) {
                    this.$message.error('请选择无异常sku信息');
                    return
                }
            }
            let messagetitle = `是否确定选中的商品无sku异常?`
            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ids = '001'
                if (type == 1) {
                    ids = this.cloudEditCurrent.id
                } else if (type == 2) {
                    if (this.checkedItems.length > 0) {
                        ids = this.checkedItems.join(',')
                    } else {
                        ids = ''
                    }
                }
                this.opPutSkudetectionDetail({
                    data: { ids: ids },
                    success: (res) => {
                        if (res.code == 200) {
                            if (res.data > 0) {
                                this.$message.success('修改成功，' + res.data + '商品')
                                if (type == 1) {
                                    this.cloudEditCurrent.status = 2
                                    this.loadCloudEditDetail()
                                    this.checkedItems = [];
                                } else {
                                    this.getDetectionDataList()
                                }
                            } else {
                                this.$message.error('修改失败，未找到商品')
                            }
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        isAllChecked() {
            return this.cloudEditProductList.length > 0 && this.checkedItems.length === this.cloudEditProductList.length;
        },
        handleCheckAllChange(val) {
            if (val) {
                this.checkedItems = this.cloudEditProductList.map(item => item.id);
            } else {
                this.checkedItems = [];
            }
        },
        handleCheckChange(val, id) {
            if (val) {
                if (!this.checkedItems.includes(id)) {
                    this.checkedItems.push(id);
                }
            } else {
                this.checkedItems = this.checkedItems.filter(itemId => itemId !== id);
            }
        },
        toggleSpecValue(val, specValue, specIndex) {
            if (specIndex == 0) {
                if (val) {
                    if (!this.selectedColorSpecValues.includes(specValue)) {
                        this.selectedColorSpecValues.push(specValue);
                    }
                } else {
                    this.selectedColorSpecValues = this.selectedColorSpecValues.filter(v => v !== specValue);
                }
            } else {
                if (!this.selectedSizeSpecValues.includes(specValue)) {
                    this.selectedSizeSpecValues.push(specValue);
                } else {
                    this.selectedSizeSpecValues = this.selectedSizeSpecValues.filter(v => v !== specValue);
                }
            }
        },
        batchDeleteSkus(type, row = '') {
            if (type == 1) {
                if (this.selectedColorSpecValues.length > 0) {
                    this.selectedColorSpecValues.sort((a, b) => Number(a) - Number(b));
                    this.selectedColorSpecValues.forEach((removeIndex, index) => {
                        this.removeSkuSpecValue(0, removeIndex - index)
                    })
                    this.selectedColorSpecValues = []
                } else {
                    this.$message.error('请选择删除SKU');
                    return
                }
            } else if (type == 2) {
                if (this.selectedSizeSpecValues.length > 0) {
                    this.selectedSizeSpecValues.sort((a, b) => Number(a) - Number(b));
                    this.selectedSizeSpecValues.forEach((removeIndex, index) => {
                        this.removeSkuSpecValue(1, removeIndex - index)
                    })
                    this.selectedSizeSpecValues = []
                } else {
                    this.$message.error('请选择删除SKU');
                    return
                }
            } else if (type == 3) {
                if (this.multipleSelection.length > 0 || row) {
                    let messagetitle = '';
                    const specList = this.cloudEditForm.skuSpecs;
                    if (specList.length === 1) {
                        messagetitle = '当前仅一组规格，仅移除选中SKU本身，不删除规格列，确认？';
                    } else {
                        messagetitle = '系统优先删除异常最多规格；若某规格仅剩1个值会自动切换或仅隐藏选中SKU，确认？';
                    }
                    this.$confirm(messagetitle, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        // 收集选中SKU
                        let targetSkus = [];
                        if (row) {
                            targetSkus = [row];
                        } else {
                            targetSkus = [...this.multipleSelection];
                        }

                        const specList = this.cloudEditForm.skuSpecs;
                        // 场景1：只有一组规格，只禁用选中sku
                        if (specList.length === 1) {
                            targetSkus.forEach(sku => {
                                sku.enabled = false;
                            });
                            this.cloudEditForm.skuSpecs = this.buildSkuSpecsFromSkus(this.cloudEditForm.skus);
                            this.setDirty();
                            this.$message.success('仅隐藏选中SKU，保留规格');
                        }
                        // 场景2：两组规格
                        else {
                            const spec0 = specList[0];
                            const spec1 = specList[1];
                            const countMap = { 0: {}, 1: {} };

                            // 统计每个规格值的异常sku数量
                            this.cloudEditForm.skus.forEach(sku => {
                                const attrs = this.normalizeSkuAttributes(sku.attributes);
                                const attr0 = attrs.find(item => item[0] === spec0.name);
                                const attr1 = attrs.find(item => item[0] === spec1.name);
                                if (!attr0 || !attr1) return;
                                const val0 = attr0[1];
                                const val1 = attr1[1];
                                const isVio = sku.violationInfo && sku.violationInfo[0]?.length > 0;
                                if (isVio) {
                                    countMap[0][val0] = (countMap[0][val0] || 0) + 1;
                                    countMap[1][val1] = (countMap[1][val1] || 0) + 1;
                                }
                            });

                            // 计算选中SKU两列总异常
                            let total0 = 0;
                            let total1 = 0;
                            targetSkus.forEach(sku => {
                                const attrs = this.normalizeSkuAttributes(sku.attributes);
                                const attr0 = attrs.find(item => item[0] === spec0.name);
                                const attr1 = attrs.find(item => item[0] === spec1.name);
                                if (!attr0 || !attr1) return;
                                const v0 = attr0[1];
                                const v1 = attr1[1];
                                total0 += countMap[0][v0] || 0;
                                total1 += countMap[1][v1] || 0;
                            });

                            // 优先选异常更高的规格下标
                            let delSpecIndex = total1 > total0 ? 1 : 0;
                            const otherIdx = delSpecIndex === 1 ? 0 : 1;
                            let finalDelIndex = delSpecIndex;

                            // 规则：目标规格只有1个值，不能删，切换另一列
                            if (specList[finalDelIndex].values.length <= 1) {
                                finalDelIndex = otherIdx;
                                // this.$message.warning(`${specList[delSpecIndex].name}仅剩1个规格，自动切换至${specList[otherIdx].name}`);
                            }

                            // 切换后另一列也只有1个值：两列都不能删规格，降级只隐藏选中SKU
                            if (specList[finalDelIndex].values.length <= 1) {
                                targetSkus.forEach(sku => {
                                    sku.enabled = false;
                                });
                                this.cloudEditForm.skuSpecs = this.buildSkuSpecsFromSkus(this.cloudEditForm.skus);
                                this.setDirty();
                                this.$message.success('两组规格均仅剩1个值，仅隐藏选中SKU，不删除规格');
                                this.multipleSelection = [];
                                return;
                            }

                            // 收集当前选中SKU对应的规格值下标
                            const targetSpec = specList[finalDelIndex];
                            const delValSet = new Set();
                            targetSkus.forEach(sku => {
                                const attrs = this.normalizeSkuAttributes(sku.attributes);
                                const matchAttr = attrs.find(item => item[0] === targetSpec.name);
                                if (!matchAttr) return;
                                const val = matchAttr[1];
                                const valIdx = targetSpec.values.indexOf(val);
                                if (valIdx > -1) delValSet.add(valIdx);
                            });

                            // 倒序删除，防止下标偏移
                            const delValIndexes = Array.from(delValSet).sort((a, b) => b - a);
                            delValIndexes.forEach(vIdx => {
                                this.removeSkuSpecValue(finalDelIndex, vIdx);
                            });
                            this.$message.success('已删除异常较多规格对应的全部关联SKU');
                        }

                        this.multipleSelection = [];
                    }).catch(() => {
                        // 取消操作无逻辑
                    })
                } else {
                    this.$message.error('请选择删除SKU');
                    return
                }
            }
        },
        formatGroupName(row) {
            let group_id = row.import_product?.group_id || '-'
            let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
            let child_group_id = row.import_product?.child_group_id || '-'
            const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
            const child_group_name = target?.name || null
            if (child_group_name) {
                group_name += '|' + child_group_name
            }
            return group_name;
        },
        getAbnormalSkuCount(row) {
            // 解析JSON字符串
            let parsedIds = {}
            try {
                parsedIds = typeof row.abnormal_sku_ids === 'string'
                    ? JSON.parse(row.abnormal_sku_ids)
                    : row.abnormal_sku_ids;
            } catch (err) {
                console.error('解析异常sku数据失败', err)
                parsedIds = {}
            }

            const textArr = []
            // 循环对象key-value
            for (const key in parsedIds) {
                const arr = parsedIds[key]
                // 只取长度大于0的数组
                if (Array.isArray(arr) && arr.length > 0) {
                    const label = this.keyNameMap[key] || '' // 无映射则显示原始key
                    if (label) {
                        textArr.push(`${label}:${arr.length}`)
                    }
                }
            }
            // || 拼接返回
            return textArr.join(' || ')

        },
        // 获取分组列表（筛选用，不需要数量）
        loadGroupList() {
            this.getCloudProductGroups({
                data: { with_count: 0 },
                success: (res) => {
                    if (res.code === 200) {
                        this.groupList = res.data || [];
                    }
                }
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        changeGroupIds(val) {
            this.$set(this.searchParams, 'child_group_ids', '')
            this.child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
            console.log(this.child_groupList);

            this.handleCloudEditFilterChange()
        },
    }
}
</script>

<style scoped>
.cloud-edit-container {
    display: flex;
    height: 72vh;
    min-height: 560px;
    gap: 12px;
    overflow: hidden;
}

.cloud-edit-left {
    width: 300px;
    min-width: 250px;
    border-right: 1px solid #ebeef5;
    padding-right: 12px;
    display: flex;
    flex-direction: column;
}

.cloud-edit-filter {
    box-sizing: border-box;
    width: 100%;
    padding: 0 0 8px;
    margin-bottom: 8px;
    background: #fff;
    gap: 6px;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.cloud-edit-right {
    flex: 1;
    min-width: 0;
    overflow-y: auto;
    padding: 0 8px 0 4px;
}

.panel-header {
    padding: 10px 0;
    font-weight: 500;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    color: #303133;
}

.edit-product-list {
    flex: 1;
    overflow-y: auto;
    margin-top: 10px;
}

.edit-product-item {
    display: flex;
    gap: 10px;
    padding: 8px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    margin-bottom: 8px;
    cursor: pointer;
    background: #fff;
}

.edit-product-item.active {
    border-color: #409eff;
    background: #ecf5ff;
}

.edit-product-thumb {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    flex-shrink: 0;
}

.edit-product-info {
    flex: 1;
    min-width: 0;
}

.edit-product-title {
    font-size: 12px;
    color: #303133;
    line-height: 1.4;
    height: 34px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.edit-product-meta {
    font-size: 12px;
    color: #f56c6c;
    line-height: 18px;
    margin-top: 4px;
}

.edit-product-status-final {
    font-size: 12px;
    color: #67c23a;
    line-height: 18px;
    margin-top: 4px;
    float: right;
}

.edit-product-status-process {
    font-size: 12px;
    color: #f56c6c;
    line-height: 18px;
    margin-top: 4px;
    float: right;
}

.edit-image-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
}

.edit-image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.edit-image-item {
    width: 96px;
    height: 96px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
}

.edit-image-item .el-image {
    width: 100%;
    height: 100%;
    cursor: zoom-in;
}

.edit-sku-table .el-input-number {
    width: 100%;
}

.sku-spec-editor {
    border: 1px solid #ebeef5;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;
    background: #fafafa;
}

.sku-spec-editor.readonly {
    background: #fff;
}

.sku-spec-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 10px;
}

.sku-spec-name {
    width: 180px;
    flex-shrink: 0;
    font-size: 12px;
    color: #303133;
    line-height: 24px;
    font-weight: 500;
}

.sku-spec-values {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.sku-disabled-text {
    color: #c0c4cc;
    text-decoration: line-through;
}

.selected-info {
    color: #909399;
    font-size: 13px;
    margin-right: 20px;
}

.sku-value-image-editor {
    border: 1px solid #ebeef5;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;
}

.sku-value-image-title {
    font-size: 13px;
    color: #303133;
    margin-bottom: 10px;
}

.sku-value-image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.sku-value-image-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
}

.sku-value-name {
    max-width: 150px;
}

.sku-value-name>>>.el-input__inner {
    font-size: 12px;
    color: #606266;
    padding: 0 6px;
    height: 24px;
}

.sku-value-thumb {
    width: 42px;
    height: 42px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: zoom-in;
}

.span_spacing {
    margin: 0 4px;
}

.violation-row {
    background-color: #fde2e2 !important;
}

.edit-sku-table /deep/ .violation-row {
    background-color: #fef0f0 !important;
}

.edit-sku-table /deep/ .violation-row:hover>td {
    background-color: #fde2e2 !important;
}

.sku-value-thumb {
    width: 42px;
    height: 42px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: zoom-in;
}

.sku-action-bar {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.edit-product-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 8px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    margin-bottom: 8px;
    cursor: pointer;
    background: #fff;
}

.edit-product-main {
    display: flex;
    gap: 10px;
    align-items: flex-start;
}

.edit-product-top {
    display: flex;
    gap: 10px;
    flex: 1;
    min-width: 0;
}

.edit-product-bottom {
    /* display: flex; */
    gap: 1px;
    font-size: 12px;
    line-height: 1.4;
    padding-left: 24px;
}


.pagination-wrap {
    /* 全局缩放，一键整体缩小，数字越小越小，0.75极致紧凑 */
    transform: scale(0.78);
    transform-origin: left center;
    /* 抵消缩放带来的高度压缩留白 */
    margin: 4px 0;

    /deep/ .el-pagination {
        font-size: 11px !important;
        display: flex;
        align-items: center;

        .el-pagination__total {
            margin-right: 4px !important;
        }

        .el-pagination__sizes {
            margin-right: 4px !important;
        }

        .el-pagination__jump {
            margin-left: 4px !important;
        }

        .el-pager li {
            height: 20px !important;
            line-height: 20px !important;
            min-width: 20px !important;
            margin: 0 1px !important;
            font-size: 11px !important;
            padding: 0 !important;
        }

        .btn-prev,
        .btn-next {
            height: 20px !important;
            min-width: 20px !important;
            padding: 0 !important;
            font-size: 11px !important;
        }

        .el-input--mini {
            width: 60px !important;
        }

        .el-input--mini .el-input__inner {
            height: 20px !important;
            line-height: 20px !important;
            font-size: 11px !important;
            padding: 0 12px 0 3px !important;
        }

        .el-input--mini .el-input__icon {
            line-height: 20px !important;
            font-size: 12px !important;
        }

        .el-pagination__jump .el-input--mini {
            width: 40px !important;
        }
    }
}
</style>